// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessPartlyRingfenced = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="m13.495 16.214-2.02-3.27v3.27H9.347v-8.53h3.301c.924 0 1.532.237 2.01.757.445.487.706 1.177.706 1.878 0 .758-.283 1.471-.75 1.89-.282.26-.554.384-1.043.52l2.575 3.485zm-.727-4.933c.239-.17.412-.532.412-.837 0-.305-.173-.645-.412-.826-.196-.147-.5-.226-.902-.226h-.39v2.115h.39c.402 0 .706-.079.902-.226z"
    />
    <path
      fill="currentColor"
      d="m19.648 5.914 1.959 4.925c.296.743.296 1.579 0 2.322l-1.958 4.925a2.977 2.977 0 0 1-1.577 1.643l-4.728 2.04a2.807 2.807 0 0 1-2.23 0l-4.728-2.04.743-1.87 4.728 2.04a.936.936 0 0 0 .743 0l4.728-2.04a.992.992 0 0 0 .526-.547l1.958-4.925a1.05 1.05 0 0 0 0-.774l-1.958-4.925z"
    />
  </svg>
);
export default SvgBusinessPartlyRingfenced;
